export default __webpack_public_path__ + "static/media/journey.eed364c5.svg";